document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-recently-viewed]');

  sections.forEach(function (section) {
    const list = section.querySelector('[data-recently-viewed-list]');
    const currentHandle = section.dataset.currentHandle;
    const storageKey = 'flowers-factory-recently-viewed';
    const limit = 5;

    if (!list) return;

    let viewed = [];

    try {
      viewed = JSON.parse(localStorage.getItem(storageKey)) || [];
    } catch (e) {
      viewed = [];
    }

    async function loadRecentlyViewed() {
      const productsToShow = viewed
        .filter(function (handle) {
          return handle !== currentHandle;
        })
        .slice(0, limit);

      if (productsToShow.length === 0) return;

      const items = await Promise.all(
        productsToShow.map(async function (handle) {
          try {
            const response = await fetch('/products/' + handle + '.js');

            if (!response.ok) return '';

            const product = await response.json();
            const image = product.featured_image || '';

            const price = new Intl.NumberFormat('en-AU', {
              style: 'currency',
              currency: 'AUD'
            }).format(product.price / 100);

            return `
              <li class="grid__item">
                <div class="card-wrapper product-card-wrapper">
                  <div class="card card--standard card--media">

                    <div
                      class="card__inner color-background-2 gradient ratio"
                      style="--ratio-percent: 100%;"
                    >
                      <div class="card__media">
                        <div class="media media--transparent media--hover-effect">
                          <img
                            src="${image}"
                            alt="${product.title.replace(/"/g, '&quot;')}"
                            loading="lazy"
                            width="600"
                            height="600"
                          >
                        </div>
                      </div>
                    </div>

                    <div class="card__content">
                      <div class="card__information">

                        <h3 class="card__heading h5">
                          <a
                            href="${product.url}"
                            class="full-unstyled-link"
                          >
                            ${product.title}
                          </a>
                        </h3>

                        <div class="card-information">
                          <span class="price">
                            ${price}
                          </span>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>
              </li>
            `;
          } catch (e) {
            return '';
          }
        })
      );

      list.innerHTML = items.join('');

      if (list.innerHTML.trim()) {
        section.style.display = '';
      }
    }

    loadRecentlyViewed();

    if (currentHandle) {
      viewed = viewed.filter(function (handle) {
        return handle !== currentHandle;
      });

      viewed.unshift(currentHandle);
      viewed = viewed.slice(0, 10);

      try {
        localStorage.setItem(storageKey, JSON.stringify(viewed));
      } catch (e) {}
    }
  });
});